export default {
  // Mutations
  SET_TOKEN: 'AUTH/SET_TOKEN',
  SET_USER: 'AUTH/SET_USER',
  // Actions
  UPDATE_DATA: 'AUTH/UPDATE_DATA',
  // Getters
  GET_TOKEN: 'AUTH/GET_TOKEN',
  GET_USER_ID: 'AUTH/GET_USER_ID'
}
